import { toColorString } from 'polished';
import styled from 'styled-components';

import color from '@decisiv/design-tokens/lib/color';
import Checkbox, {
  Props as CheckboxProps,
} from '@decisiv/ui-components/lib/components/Checkbox';

export const SelectAllCheckbox = styled(Checkbox)<CheckboxProps>`
  label {
    color: ${toColorString(color.interaction.pacificOcean)}}
  }
`;
